module.exports = __webpack_public_path__ + "media/tb colitis.754d8f59.wav";